import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onAction }) => {
  const actions = [
    {
      id: 'book-class',
      label: 'Book Class',
      description: 'Reserve your spot',
      icon: 'Calendar',
      color: 'primary',
      path: '/class-booking'
    },
    {
      id: 'view-programs',
      label: 'Workout Programs',
      description: 'Browse training plans',
      icon: 'Dumbbell',
      color: 'accent',
      path: '/workout-programs'
    },
    {
      id: 'manage-payment',
      label: 'Payments',
      description: 'View billing history',
      icon: 'CreditCard',
      color: 'success',
      path: '#'
    },
    {
      id: 'guest-pass',
      label: 'Guest Pass',
      description: 'Invite a friend',
      icon: 'UserPlus',
      color: 'warning',
      path: '#'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/10 text-primary hover:bg-primary/20',
      accent: 'bg-accent/10 text-accent hover:bg-accent/20',
      success: 'bg-success/10 text-success hover:bg-success/20',
      warning: 'bg-warning/10 text-warning hover:bg-warning/20'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  return (
    <div className="card">
      <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-6">
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onAction(action?.id, action?.path)}
            className={`
              p-5 rounded-lg border border-border text-left
              transition-all duration-250 hover:shadow-md hover:scale-105
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
            `}
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${getColorClasses(action?.color)}`}>
                <Icon name={action?.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-medium text-foreground mb-1">
                  {action?.label}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {action?.description}
                </p>
              </div>
              <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" className="flex-shrink-0" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;